export enum ZoneType {
  ObjectZone = 130,
  CustomerZone = 128
}
